import { render, staticRenderFns } from "./Nobilium.vue?vue&type=template&id=c1756bbe&"
import script from "./Nobilium.vue?vue&type=script&lang=js&"
export * from "./Nobilium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports